import { useEffect } from 'react';

export const useDocumentTitle = (title: string, prevailOnUnmount = false) => {
  useEffect(() => {
    document.title = `${title} | Sendit Gigs`;
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = 'Sendit Gigs';
      }
    },
    [prevailOnUnmount]
  );
};
